<script setup>
import Hero from '@sections/about/hero.vue'
import Team from '@sections/about/team.vue'
import WhoWeAre from '@sections/about/who-we-are.vue'
import Delimiter from '@sections/delimiter.vue'
import Location from '@sections/location.vue'
import Socials from '@sections/merch/socials.vue'
</script>

<template>
	<Hero />
	<WhoWeAre />
	<Location />
	<Team />
	<div class="bg-bgSecondary">
		<Socials :dark="true" />
	</div>
	<Delimiter :isDark="true" />
</template>
